exports.IDS = {
  // IMG_URL: "http://127.0.0.1:1515",
  IMG_URL: "https://myflowereventnode.profcymadev.com:1519",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
